import { useEffect } from "react";
import { IHook } from "./homeGoogle.types";

export const useHomeGoogleB: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
